import React from 'react';
import { graphql, Link } from 'gatsby';
import get from 'lodash/get';
import { DiscussionEmbed } from 'disqus-react';
import classNames from 'classnames';

import Page from 'components/page';

import SectionContainer from 'components/sectionContainer';
import { Title } from 'components/typography';
import { ArrowLeftIcon } from 'components/icons';

import UpdateMeta from './UpdateMeta';
import UpdateSocialShare from './UpdateSocialShare';
import {
  postContainer,
  postTitle,
  postContent,
  socialShareContainer,
  backToUpdatesLink,
  commentsContainer,
  marginButtomMd,
  postContentContainer,
} from './scss/Update.module.scss';
import { getDisqusConfig, normalizePost } from './Update.helpers';

const Update = props => {
  const wpPost = get(props, 'data.wordpressPost', {});
  const post = normalizePost(wpPost);
  return (
    <Page pageName="Update" pageData={post}>
      <SectionContainer>
        <div className={postContainer}>
          <div
            className={classNames(socialShareContainer, 'd-none d-md-block')}
          >
            <UpdateSocialShare postTitle={post.title} />
          </div>
          <div className={postContentContainer}>
            <article>
              <Link to="/updates" className={backToUpdatesLink}>
                <small>
                  <ArrowLeftIcon /> All Articles
                </small>
              </Link>
              <Title
                renderAsHtml
                value={post.title}
                size="xl"
                className={postTitle}
              />
              <UpdateMeta post={post} />
              <div
                className={postContent}
                dangerouslySetInnerHTML={{ __html: post.content }}
              />
            </article>
            <div
              className={classNames(socialShareContainer, 'd-block d-md-none')}
            >
              <UpdateSocialShare postTitle={post.title} />
            </div>
            <section className={commentsContainer}>
              <Title value="Comments" size="lg" className={marginButtomMd} />
              <DiscussionEmbed {...getDisqusConfig(post)} />
            </section>
          </div>
        </div>
      </SectionContainer>
    </Page>
  );
};

export default Update;
export const pageQuery = graphql`
  query($id: String!) {
    wordpressPost(id: { eq: $id }) {
      id
      title
      slug
      status
      content
      format
      categories
      jetpack_featured_media_url
      date(formatString: "DD.MM.YYYY")
      link
      author {
        name
        avatar_urls {
          wordpress_96
        }
      }
    }
  }
`;
